import _ from 'lodash';
import { createFsDocKey_alt } from '../../../global/firestoreData/appData/fsAppData';
import { seasonalUpdateTypes } from '../cnr/reducers/reducerHelpers/seasonalDataHelpers';
import { gameScoringTypes } from '../cnr/reducers/SportsSeasonReducer';
import { sgs } from '../helpers/scheduleGrids';
import { _mediaHeaders } from '../helpers/sportsEnums';

export const updateScheduledMatches = async (usd, paps_state, latestSeason, scheduleProps, callback) => {

  const { update_seasonalOrGlobal, getUpdateProps, getPks } = usd
  const { pathViews } = paps_state
  const pks = getPks(pathViews, latestSeason)
  // updates `_seasonals`

  // getUpdateProps: (sportPermissions, pks, callback, collectionName, documentFieldName, data, opts, dataInfos, _sportsYearAbr
  const _updateProps = getUpdateProps(pathViews, pks, callback, null, 'matches', scheduleProps.matches_combined)
  update_seasonalOrGlobal(seasonalUpdateTypes.matches, _updateProps)

}

export const createScheduledMatches = (database_fns, mainDb, seasonMatchesProps, matches_season) => {

  const {
    crossSectionDates,
    gameScoringType,
    gridMatches,
    homeAways,
    matches,
    _matches,
    sectionCrossovers,
    sectionDates,
    teams,
    _sportsAbr,
    forceRefresh,
  } = seasonMatchesProps ?? {}

  // if we already have matches from the seasonal object, return them
  if (!_.isEmpty(matches) && !forceRefresh) {
    console.log('_matches !!!', _matches)
    return {
      matches: matches,
    }
  }

  const matches_grid = {}
  const allCM = {}

  const levels = _.groupBy(teams, 'levels')
  const sportInfo = { startTime: '7:00 PM' }

  if (gridMatches) {
    gridMatches.forEach(gm => {
      const _key = database_fns.get_docKey()
      matches_grid[_key] = {
        startDate: gm.startDate ? gm.startDate : '?????',
        startTime: '7:00 PM',
        home: gm.home,
        away: gm.away,
        levels: gm.levels,
        sections: gm.sections,
        teams: [gm.home.id, gm.away.id],
        key: gm.away.name + '-' + gm.home.name,
        _matchCollectionKey: gm.levels
      }
    })
  } else {

    const crossoverKeys = []

    _.forEach(levels, (level, levelKey) => {
      const sections = _.groupBy(level, 'sections')
      _.forEach(sections, (sectionTeams, sectionKey) => {
        const _levelSectionKey = levelKey + '_' + sectionKey
        const _homeAway = homeAways[_levelSectionKey]

        const teamCount = _.size(sectionTeams)
        const sectionDates_selected = sectionDates && sectionDates[teamCount] ? sectionDates[teamCount] : []
        if (sectionDates_selected) {
          let _teamCount = teamCount
          if (_sportsAbr === 'WS' && teamCount === 5) {
            _teamCount = 'ws_' + teamCount
          }
          const playGrids = sgs.wpial_home_away[_teamCount]
          if (playGrids) {
            for (var allezRetour = 1; allezRetour <= 2; allezRetour++) {
              createMatches(mainDb, sectionTeams, allezRetour, sectionDates_selected, sportInfo, playGrids, matches_grid, _homeAway, gameScoringType, _sportsAbr, matches_season)
            }
          }
        }

        if (sectionCrossovers) {

          const sectionCrossoverKey = sectionCrossovers[_levelSectionKey]

          if (!crossoverKeys.includes(_levelSectionKey)) {

            const _sectionCrossover = sectionCrossoverKey.split('_')
            const _levelKey = _sectionCrossover[0]
            const _sectionKey = _sectionCrossover[1]
            const _crossoverSectionTeams = sections[_sectionKey]
            const teamCount = _.size(_crossoverSectionTeams)
            const selectedCrossoverDates = crossSectionDates && crossSectionDates[teamCount] ? crossSectionDates[teamCount] : []
            const crossoverGrids = sgs.crossover[teamCount]
            // const playGrids = sgs.wpial_home_away[teamCount]
            if (crossoverGrids) {
              const _homeAway = homeAways && homeAways[_levelSectionKey] ? homeAways[_levelSectionKey] : homeAway
              createCrossoverMatches(sectionTeams, _crossoverSectionTeams, allezRetour, selectedCrossoverDates, sportInfo, crossoverGrids, allCM, _homeAway, gameScoringType)
              crossoverKeys.push(sectionCrossoverKey)
            }
          }
        }
      })
    })
  }


  return {
    matches: matches_grid,
    crossoverMatches: allCM,
  }
}

const createMatches = (mainDb, teams, allezRetour, selectedDates, sportInfo, playGrids, allM, homeAway, gameScoringType, _sportsAbr, matches_season) => {

  const _dates = sortDateStrings(selectedDates)

  // loop the grids
  let pdi = (allezRetour === 2) ? Object.keys(playGrids).length : 0

  if (playGrids) {
    _.forEach(playGrids, (gridMatches) => {
      if (gridMatches) {
        _.forEach(gridMatches, (gridMatch) => { // gridMatch = {h: 1, a: 6}
          const _match = getMatch(teams, gridMatch, homeAway, allezRetour)
          const mm = matches_season ? matchingMatch(matches_season, _match) : null
          const newMatch = createMatch(_match, _dates[pdi], sportInfo.startTime, gameScoringType)
          const _key = mm?._itemKey || createFsDocKey_alt(mainDb)
          allM[_key] = newMatch
          if (mm) {
            allM[_key]._isExistingMatch
          }
        })
      }
      pdi++
    })
  }

}

const matchingMatch = (matches_season, match) => {
  return _.find(
    matches_season,
    item =>
      item?.away?.id === match?.away?.id &&
      item?.home?.id === match?.home?.id
  )

}

function sortDateStrings(dates) {
  return dates
    .map(str => ({ str, date: new Date(str) })) // parse strings
    .sort((a, b) => a.date - b.date)           // sort by actual date
    .map(item => item.str);                    // return strings
}


const createCrossoverMatches = (teams, crossoverTeams, allezRetour, selectedDates, sportInfo, playGrids, allM, homeAway, gameScoringType) => {

  let _isHome = true

  if (playGrids) {
    let pdi = (allezRetour === 2) ? Object.keys(playGrids).length : 0
    _.forEach(teams, (team) => {
      const { position, levels } = team ?? {}
      _.forEach(playGrids, (gridMatches, playDateNumber) => {
        if (gridMatches) {
          const gridMatch = gridMatches[position + 1]
          const { o } = gridMatch ?? {}
          const opponent = getTeamByPosition(crossoverTeams, o)
          const newMatch = {
            home: _isHome ? team : opponent,
            away: _isHome ? opponent : team,
            startDate: selectedDates[playDateNumber - 1],
            levels: levels,
            sections: _mediaHeaders.nonSection,
            isCrossover: true,
            teams: [team.id, opponent.id],
          }
          const _key = database_fns.get_docKey()
          allM[_key] = newMatch
          _isHome = !_isHome
        }
        pdi++
      })
    })
  }
}

const getMatch = (teams, gridMatch, homeAway, allezRetour) => {
  const newMatch = {
    home: { ...getHomeAway(homeAway, teams, gridMatch, allezRetour, true) },
    away: { ...getHomeAway(homeAway, teams, gridMatch, allezRetour, false) },
  }
  return newMatch
}

const createMatch = (newMatch, startDate, startTime, gameScoringType) => {

  newMatch.startDate = startDate || '???---???'
  newMatch.startTime = startTime
  newMatch._created = true

  switch (gameScoringType) {
    case gameScoringTypes.match:
    case gameScoringTypes.matchPoints:
      newMatch.bestOf = true
      newMatch.setCount = 5
      break;
    default:
    // nothing
  }

  newMatch.key = newMatch.away.name + '-' + newMatch.home.name
  newMatch.teams = [newMatch.home.id, newMatch.away.id]

  if (newMatch.away.levels === newMatch.home.levels) {
    newMatch.levels = newMatch.home.levels
    newMatch._matchCollectionKey = newMatch.home.levels
  } else {
    newMatch.levels = _mediaHeaders.nonLevel
  }
  if (newMatch.away.sections === newMatch.home.sections) {
    newMatch.sections = newMatch.home.sections
  } else {
    newMatch.sections = _mediaHeaders.nonSection
  }
  return newMatch
}

const getHomeAway = (homeAway, teams, gridMatch, allezRetour, isHome) => {
  if (homeAway) {
    if (isHome) {
      if (allezRetour === 1) {
        return getTeamByPosition(teams, gridMatch.a)
      } else {
        return getTeamByPosition(teams, gridMatch.h)
      }
    } else {
      if (allezRetour === 1) {
        return getTeamByPosition(teams, gridMatch.h)
      } else {
        return getTeamByPosition(teams, gridMatch.a)
      }
    }
  } else {
    if (isHome) {
      if (allezRetour === 1) {
        return getTeamByPosition(teams, gridMatch.h)
      } else {
        return getTeamByPosition(teams, gridMatch.a)
      }
    } else {
      if (allezRetour === 1) {
        return getTeamByPosition(teams, gridMatch.a)
      } else {
        return getTeamByPosition(teams, gridMatch.h)
      }
    }
  }
}


const getTeamByPosition = (teams, teamNumber, withParents) => {

  const rTeam = {}

  const team = _.find(teams, (team) => team.position + 1 === teamNumber);

  if (team) {
    const { id, _itemKey } = team
    rTeam.id = id ? id : _itemKey
    rTeam._itemKey = id ? id : _itemKey
    rTeam.name = team.name
    rTeam.sections = team.sections
    rTeam.levels = team.levels
    if (withParents) {
      rTeam.organizations = team.parentKeys.organizations
      rTeam.districts = team.parentKeys.districts
    }
  }

  return rTeam
}
